<header class="flex header">
  <h2>
    {{ 'fabricInfoModal.title' | translateWF: 'Fabric Information' }}
  </h2>
  <p-button icon="pi pi-times" (click)="onClose()" />
</header>
<section class="content">
  <div class="form-box">
    <label for="">
      {{ 'fabricInfoModal.fabricCode' | translateWF: 'Fabric Code' }}
    </label>
    <input pInputText type="text" class="w-full" [value]="fabric?.fabricCode" [disabled]="true" />
  </div>

  <div class="mt-5">
    <p>
      <b> {{ 'fabricInfoModal.fabricComposition' | translateWF: 'Fabric Composition' }}</b>
    </p>

    @if (fabricComposition) {
      <app-card-composition [fabricComposition]="fabricComposition" />
    } @else {
      <p-message severity="error">{{ 'fabricInfoModal.noFabricComposition' | translateWF: 'No Fabric Composition' }}</p-message>
    }
  </div>
</section>

<footer>
  <p-button class="w-full" [label]="'Exit' | translateWF: 'Exit'" variant="outlined" (click)="onClose()" />
</footer>
